import { matchesShortcut } from "@/lib/shortcuts";
import type { DictationStatus } from "./use-dictation";
import { getWindowRoleSync } from "./use-window-role";

type DictationCancelSnapshot = {
  status: DictationStatus;
  cancel: () => Promise<void>;
};

export function attachDictationEscapeCancel(
  getState: () => DictationCancelSnapshot,
  isRequestActive: () => boolean,
  cancelLocalRequest: () => void,
): void {
  window.addEventListener(
    "keydown",
    (event) => {
      if (!matchesShortcut("shortcut.voice.cancel", event)) return;
      const { status, cancel } = getState();
      const requestActive = isRequestActive();
      // The owner may already have mirrored idle before this display receives
      // Escape. Invalidate even then so its late final cannot become a request.
      cancelLocalRequest();
      if (status !== "recording" && status !== "processing" && !requestActive)
        return;
      event.preventDefault();
      event.stopPropagation();
      if (getWindowRoleSync() === "owner") void cancel();
    },
    true,
  );
}
